(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PointDialogController', PointDialogController);

    PointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Point'];

    function PointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Point) {
        var vm = this;

        vm.point = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.point.id !== null) {
                Point.update(vm.point, onSaveSuccess, onSaveError);
            } else {
                Point.save(vm.point, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:pointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
